import { extendTheme, withDefaultColorScheme } from "@chakra-ui/react";

export const theme = extendTheme(
  {
    config: {
      initialColorMode: "light",
      useSystemColorMode: false,
    },
    semanticTokens: {
      colors: {
        link: {
          default: "#00AE42",
        },
        primary: {
          default: "#00AE42",
        },
        secondary: {
          default: "rgb(84, 86, 90)",
        },
        borderColor: "rgb(84, 86, 90)",
      },
    },
    shadows: {
      sm: "0px 6px 10px rgba(0, 0, 0, 0.06)",
    },
    components: {
      Table: {
        baseStyle: {
          color: "rgb(84, 86, 90)",
          td: {
            verticalAlign: "baseline",
          },
          th: {
            textTransform: "none !important",
            fontWeight: 700,
          },
        },
      },
      Heading: {
        baseStyle: {
          color: "accent",
          textAlign: "left",
        },
      },
      Link: {
        baseStyle: {
          textDecoration: "none",
          _hover: {
            textDecoration: "none",
          },
        },
        variants: {
          link: {
            color: "link",
            _hover: {
              textDecoration: "underline",
            },
          },
        },
      },
      Switch: {
        baseStyle: {
          outline: "none",
          _active: {
            boxShadow: "none",
          },
          _focus: {
            outline: "none",
            boxShadow: "none",
          },
        },
      },
      Select: {
        defaultProps: {
          focusBorderColor: "rgba(0, 0, 0, 0.14)",
        },
        baseStyle: {
          "&.chakra-menu__menu-list": {
            maxH: "300px",
          },
          borderRadius: "12px",
          outline: "none !important",
          background: "none",
          field: {
            _focus: {
              borderColor: "#00AE42",
            },
            _autofill: {
              border: "1px solid transparent",
              textFillColor: "rgb(84, 86, 90)",
              transition: "background-color 5000s ease-in-out 0s",
            },
            _placeholder: { color: "rgb(84, 86, 90) !important" },
          },
        },
      },
      Menu: {
        baseStyle: {
          list: {
            shadow: "lg",
            "&:focus:not([data-focus-visible-added])": {
              shadow: "lg",
            },
            background: "white",
          },
        },
      },
      Button: {
        baseStyle: {
          padding: "8px 31px",
          borderRadius: "8px",
          outline: "none !important",
        },
        variants: {
          solid: {
            color: "white",
          },
          secondary: {
            background: "rgb(84, 86, 90)",
            color: "white",
          },
          tiertary: {
            background: "transparent",
            color: "white",
          },
        },
      },
      Input: {
        baseStyle: {
          borderRadius: "12px",
          padding: "20px",
          outline: "none !important",
          background: "none",
          field: {
            _focus: {
              borderColor: "#00AE42",
            },
            _autofill: {
              border: "1px solid transparent",
              textFillColor: "rgb(84, 86, 90)",
              transition: "background-color 5000s ease-in-out 0s",
            },
            _placeholder: { color: "rgb(84, 86, 90) !important" },
          },
        },
      },
      NumberInput: {
        baseStyle: {
          borderRadius: "12px",
          padding: "20px",
          outline: "none !important",
          background: "none",
          field: {
            _focus: {
              borderColor: "#00AE42",
            },
            _autofill: {
              border: "1px solid transparent",
              textFillColor: "rgb(84, 86, 90)",
              transition: "background-color 5000s ease-in-out 0s",
            },
            _placeholder: { color: "rgb(84, 86, 90) !important" },
          },
        },
      },
      input: {
        baseStyle: {
          borderRadius: "12px",
          padding: "20px",
          outline: "none !important",
          background: "none",
          field: {
            _focus: {
              borderColor: "#00AE42",
            },
            _autofill: {
              border: "1px solid transparent",
              textFillColor: "rgb(84, 86, 90)",
              transition: "background-color 5000s ease-in-out 0s",
            },
            _placeholder: { color: "rgb(84, 86, 90) !important" },
          },
        },
      },
      Text: {
        baseStyle: {
          marginTop: "0px !important",
        },
      },
      IconButton: {
        baseStyle: {
          outline: "none !important",
        },
      },
    },
  },
  withDefaultColorScheme({ colorScheme: "primary" })
);
